import getFullName from './getFullName';

export default contact => {
  const fullName = getFullName(contact);
  return fullName || contact?.email;
};
